export const PERMISSION_MODULES = {
  //information
  VESSEL_INFORMATION: 'VesselInformation',
  VESSEL_INFORMATION_SPECIFICATION: 'VesselInformation-Specification',
  VESSEL_INFORMATION_TANKS: 'VesselInformation-Tanks',
  VESSEL_INFORMATION_PHOTOS: 'VesselInformation-Photos',
  VESSEL_INFORMATION_CONTRACT: 'VesselInformation-Contract',
  VESSEL_INFORMATION_FORMALITY: 'VesselInformation-Formality',
  VESSEL_INFORMATION_MAINTENANCE: 'VesselInformation-Maintenance',
  VESSEL_INFORMATION_CHARGE_CODE: 'VesselInformation-ChargeCode',
  VESSEL_INFORMATION_OIL_HAZMAT_TRAINING: 'VesselInformation-OilSpillAndHazmatTraining',
  VESSEL_INFORMATION_AUDIT_LOG: 'VesselInformation-AuditLog',
  VESSEL_CONFIGURATION: 'VesselConfigurationMaster',
  SENIOR_OFFICER_ORIENTATION: 'Crew',
  VESSEL_ZONING: 'BulkVesselZoning',
  VESSEL_ZONING_SEARCH: 'BulkVesselZoningSearch',
  VESSEL_ZONING_LIST: 'BulkZoningList',

  //Inspection
  QUESTIONNAIRE_ADD_EDIT: 'QuestionnaireAddEdit',
  QUESTIONNAIRE_SEARCH: 'QuestionnaireSearch',

  //Operation
  OPERATION_DOR_CREATE: 'OperationDORCreate',
  OPERATION_NEW_DOR: 'OperationNewDOR',
  OPERATION_DOR_SUMMARY: 'OperationDORSummary',
  OPERATION_ON_OFF_HIRE_CREATE: 'OperationOnOffHireCreate',
  ARRIVAL: 'Arrival',
  DEPARTURE: 'Departure',

  //bulk
  SUMMARY_DEMAND_WEEKLY: 'SummaryDemandWeekly',
  SUMMARY_7_DAY_PLAN: 'Summary7DayPlan',
  SEARCH_RIG_OPERATION_PLAN: 'SearchRigOperationPlan',
  BULK_RIG_ROB: 'BulkRigRob',
  DRY_BULK_WEEKLY_PLAN: 'DryBulkWeeklyPlan',
  BULK_DAILY_ROB_REPORT: 'BulkDailyROBReport',

  //Material Request
  CREATE_MATERIAL_REQUEST: 'CreateMaterialRequest',
  ALL_MATERIAL_REQUEST: 'AllMaterialRequest',

  //Vessel Route
  CURRENT_PLAN: 'Current Plan',
  WEEKLY_VESSEL_ROUTE: 'WeeklyVesselRoute',
  DAILY_VESSEL_ROUTE: 'DailyVesselRoute',
  VESSEL_SUPPORT_ACTIVITY: 'VesselSupportActivity',
  VESSEL_BOOKING_ACTIVITY: 'VesselBookingActivity',
  TRAFFIC_PLAN: 'TrafficPlan',
  ACTIVE_ROUTE: 'Vessel Schedule',

  //Shorebase
  SHOREBASE_VESSEL_PORT_CALL: 'ShorebaseVesselPortCall',
  SHOREBASE_VESSEL_PORT_CALL_SEARCH: 'ShorebaseVesselPortCallSearch',
  SHOREBASE_VESSEL_TASK: 'ShorebaseVesselTask',
  SHOREBASE_VESSEL_TASK_SEARCH: 'ShorebaseVesselTaskSearch',
  OIL_TEX_INVOICE: 'OilTexInvoice',
  VESSEL_PORT_CALL_FUEL_TRACKING: 'VesselPortCallAndFuelTracking',
  WATER_SUPPLY_TO_VESSEL: 'WaterSupplyToVessel',
  DAILY_BULK_MOVEMENT: 'DailyBulkMovement',
  KPI: 'KPI',
  PORT_DIAGRAM: 'PortDiagram',
  ACTIVITY_VESSELS_CHECK_IV: 'ActivityVesselsforcheckIV',
  CARGO_WEIGHT_AND_LIFT: 'CargoWeightAndLift',

  //reports
  DOR_ACTIVITY_BULK_TRANSFERRING: 'DORActivityBulkTransferring',
  ALLOCATION_REPORT: 'AllocationReport',

  //Admin
  USER_MANAGEMENT: 'UserManagement',
  ROLE_MANAGEMENT: 'RoleManagement',
  DOR_ASSET_MASTER: 'DORAssetMaster',
  DOR_FIELD_MASTER: 'DORFieldMaster',
  DOR_PLATFORM_MASTER: 'DORPlatformMaster', //location management
  DEPARTMENT_MASTER: 'DepartmentMaster', //department management
  RIG_CAPACITY: 'RigCapacity',
  METER_MASTER: 'MeterMaster',
  SHOREBASE_RATE_MASTER: 'ShorebaseRateMaster',
  SHOREBASE_PORT_MASTER: 'ShorebasePortMaster',
  CHARGE_CODE_MASTER: 'ChargeCodeMaster',
  MASTER_DATA: 'Master Data', // master data
  DOR_ACTIVITY_CONDITION_MASTER: 'DORActivityConditionMaster',
} as const;

/** Action names as stored against a module's permissions. Add new actions here as they appear. */
export const PERMISSION_ACTIONS = {
  ADD: 'Add',
  EDIT: 'Edit',
  DELETE: 'Delete',
  CANCEL: 'Cancel',
  VIEW: 'View',
  VIEW_PAGE: 'ViewPage',
  SAVE: 'Save',
  SEND_EMAIL: 'SendEmail',
  IMPORT: 'Import',
  EXPORT_TO_EXCEL: 'Export to Excel',
  DOWNLOAD: 'Download',
  REVOKE_ONBOARD: 'RevokeOnboard',
  CONFIRM_ONBOARD: 'ConfirmOnboard',
  DELIVERED: 'Delivered',
  ArrivedAtJetty: 'ArrivedAtJetty',
  RevokeTo: 'RevokeTo',
  RemoveCargo: 'RemoveCargo',
  PostponeCargo: 'PostponeCargo',
  SaveForLoadingList: 'SaveForLoadingList',
  MoveTo: 'MoveTo',
  AllMaterialRequests: 'AllMaterialRequests',
  VIEW_ALL_MATERIAL_REQUEST: 'View all material request',
  REMOVE_CARGO_FROM_CANCELLED_LOCATION: 'Remove Cargo From Cancelled Location',
  RemoveLocation: 'RemoveLocation',
  AddVSIT: 'AddVSIT',
  ExportLoadingList: 'ExportLoadingList',
  ExportChevronCargoManifest: 'ExportChevronCargoManifest',
  ExportDGcargoManifest: 'ExportDGcargoManifest',
} as const;

export type PermissionAction = (typeof PERMISSION_ACTIONS)[keyof typeof PERMISSION_ACTIONS];
